import { createSlice } from "@reduxjs/toolkit";

interface IActiveAssetID {
  value: number;
}

const initialState: IActiveAssetID = { value: 0 };

const activeAssetIDSlice = createSlice({
  name: "activeAssetID", // slice name used in store
  initialState: initialState, // default state
  reducers: {
    update: (state, action) => {
      state.value = action.payload;
    },
  },
});

// Export the actions to use in components
export const { update } = activeAssetIDSlice.actions;

// Export the reducer to use in the store
export default activeAssetIDSlice.reducer;
